module.exports = __webpack_public_path__ + "src/img/verify-fail-logo.3a853ffc.svg";